import { render } from "./InvestorOverviewContent.vue?vue&type=template&id=1a105c77&scoped=true"
import script from "./InvestorOverviewContent.vue?vue&type=script&lang=js"
export * from "./InvestorOverviewContent.vue?vue&type=script&lang=js"

import "./InvestorOverviewContent.vue?vue&type=style&index=0&id=1a105c77&scoped=true&lang=css"
import "./InvestorOverviewContent.vue?vue&type=style&index=1&id=1a105c77&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a105c77"]])

export default __exports__